export default __webpack_public_path__ + "static/media/retailors-active.6666671a.svg";